import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ContentService } from 'src/app/services/content.service';
import { DrawingService } from 'src/app/services/drawing.service';
import { MultimodalService } from 'src/app/services/multimodal.service';
import { VoiceControlService } from 'src/app/services/voice-control.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

  menu_visible = false;
  public contact_info: any;

  constructor(@Inject(DOCUMENT) private document: Document, private router: Router, private voiceControlService: VoiceControlService,
              private contentService: ContentService, public multimodalService: MultimodalService, private drawingService: DrawingService, private ngZone: NgZone) {

      this.voiceControlService.link.subscribe(res => {
        this.ngZone.run(()=>this.navigateTo(res));
      });

      this.voiceControlService.changeTheme.subscribe(res => {
        this.updateTheme(res);

      });

      this.voiceControlService.showNavigationMenu.subscribe(res => {
        this.showNavigationMenu();
      });

      this.voiceControlService.openUrl.subscribe(res => {
        let url: string;
        if (res === 'mail') {
          url = 'mailto:' + this.contact_info.email;
        } else if (res === 'linkedin' || res === 'twitter') {
          url = this.contact_info.social_media.filter(s => s.name.toLowerCase() === res)[0].url;
        }
        window.open(url, '_blank');
      });

  }

  navigateTo(link: string) {
    this.multimodalService.playHapticButtonClick(100);
    this.router.navigate(['', link ]);
    window.scrollTo(0,0);

    this.document.getElementById('image-cursor').style.backgroundImage = 'none';
    this.document.getElementById('image-cursor').style.opacity = '0';
    if (this.menu_visible) {
      this.showNavigationMenu();
    }
  }




  showNavigationMenu() {
    this.menu_visible = !this.menu_visible;
    this.multimodalService.playAudioSlide();
    this.multimodalService.playHapticButtonClick([150, 200, 100]);
    this.multimodalService.config.inputActive = false;
    this.multimodalService.config.inputFocus = false;
    if (this.menu_visible) {

      this.document.getElementById('sidebar-menu').classList.add('open');
      this.document.getElementById('menu-icon').classList.add('open');
      setTimeout(() => {
        this.document.getElementById('full-screen-menu').classList.add('visible');
        this.document.getElementById('open-menu').classList.add('animate');
        this.document.getElementById('menu-contact-details').classList.add('animate');
      }, 200);
    } else {

      this.document.getElementById('full-screen-menu').classList.remove('visible');
      setTimeout(() => {
        this.document.getElementById('sidebar-menu').classList.remove('open');
        this.document.getElementById('menu-icon').classList.remove('open');
        this.document.getElementById('open-menu').classList.remove('animate');
        this.document.getElementById('menu-contact-details').classList.remove('animate');

      }, 500);
    }
  }

  ngOnInit() {
    this.contentService.getContactInfo().subscribe(res => {
      this.contact_info = res;
    });
  }

  updateTheme(voicecontrolled = null) {
    this.multimodalService.playAudioSlideClick();
    this.multimodalService.playHapticButtonClick([100, 50, 100]);
    this.multimodalService.config.theme = this.multimodalService.config.theme === 'light-mode' ? 'dark-mode' : 'light-mode';
    this.drawingService.changeMode(this.multimodalService.config.theme);
    this.multimodalService.updateTheme(this.multimodalService.config.theme);
    if (voicecontrolled) {
      (this.document.getElementById('toggleSwitch') as HTMLInputElement).checked = voicecontrolled === 'dark-mode' ? true : false;
    }
  }

  linkTo(url: string) {
    this.multimodalService.playAudioClick();
    this.multimodalService.playHapticButtonClick(150);
    window.open(url);
  }
}
